// Security Profiles Main Page component (imported and rendered in ACLs.js in Routes directory)
// This component is in form of a function component, all the data related to Security settings
// main page is displayed through this component, since this is the main component, it is the parent
// to other child components imported at the top level, such as <ContentHeader/>, etc.
// Stylesheets related to this page are imported here (SecurityProfiles.scss)
import React, { useState, useEffect, useCallback } from "react";
import { NavLink } from "react-router-dom";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import Pencil from "../../../../../Assets/Images/pencil.svg";
import Plus from "../../../../../Assets/Images/ButtonPlus.svg";
import Delete from "../../../../../Assets/Images/delete.svg";
import EmptyState from "../../../../../Assets/Images/EmptyState.svg";
import Up from "../../../../../Assets/Images/up.svg";
import "../../../../../Assets/Styles/SecurityProfiles.scss";
import Collapsible from "react-collapsible";
import SearchInput from "../../ShareElements/TextInput/SearchInput";
import MultiSelect from "../../ShareElements/Select/MultiSelect";
import Alert from "../../ShareElements/Alert/Alert";
import DesktopOnlyPageOverlay from "../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import TableFilter from "../../ShareElements/TableFilter/TableFilter";
import axios from "axios";
import { Config } from "../../../../../Config";
import MultipleDeleteAlert from "../../ShareElements/Alert/MultipleItemDeleteAlert";
import ErrorModal from "../../ShareElements/Alert/ErrorModal";
import PaginationRowSelector from "../Components/PaginationRowSelector";

const ACLs = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const [DeleteMultipleIsOpen, setDeleteMultipleIsOpen] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  // *filter data with initial values* //
  const [IsActive, setIsActive] = useState(true);
  const [NameLike, setNameLike] = useState("");
  const [Direction, setDirection] = useState("ASC");
  const [Start, setStart] = useState(0);
  const [ItemIDs, setItemIDs] = useState([]); // used for checkboxes
  const [SelectedItems, setSelectedItems] = useState([]);
  // ** //
  const [ACLsList, setACLsList] = useState([]);
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);
  const [Pages, setPages] = useState([]);
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const [TotalElements, setTotalElements] = useState();
  const [PreviousModalId, setPrevModalId] = useState();
  const [ItemIdToDelete, setIdToDelete] = useState("");
  const [StatusFilterCounter, setStatusFilterCounter] = useState(0); // 0: all 1:active 2:inactive
  const [PrevId, setPrevId] = useState("");
  const [ACLMappings, setACLMappings] = useState([]);
  const [DeleteError, setDeleteError] = useState({
    isShown: false,
    currentlyUsed: [],
  });
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [SelectedSize,  setSelectedSize] = useState(5)

  useEffect(() => {
    getFilteredData();
    getACLMappings();
    window.localStorage.removeItem("CreatedACLId");
    window.localStorage.removeItem("MappingCreated");
    window.localStorage.removeItem("CreatedACLName");
    window.localStorage.removeItem("BasicSettingsCreated");
    window.localStorage.removeItem("HasUnsaveChanges");
    window.localStorage.removeItem("Enabled");
    window.localStorage.removeItem("IncludeAllRecords");
    window.localStorage.removeItem("IncludeOwnRecords");
    window.localStorage.removeItem("IncludeUnAssigned");
    window.localStorage.removeItem("SelectedACL");
  }, []);
  useEffect(() => {
    updatePagination();
  }, [TotalElements]);

  const getACLMappings = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.ACLBaseURL + "/api/location/search/all",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createMappingData(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  // used for page filters (mappings dropdown filter)
  const createMappingData = (APIresult) => {
    let Bunits = [];
    let Countries = [];
    let Departments = [];
    let Regions = [];
    APIresult.businesses.map((Bunit) => {
      Bunits.push({
        name: "Business Unit / " + Bunit.name,
        id: Bunit.id,
        type: "BusinessUnit",
      });
    });
    APIresult.countries.map((Country) => {
      Countries.push({
        name: "Country / " + Country.name,
        id: Country.id,
        type: "Country",
      });
    });
    APIresult.departments.map((Dept) => {
      Departments.push({
        name: "Department / " + Dept.name,
        id: Dept.id,
        type: "Department",
      });
    });
    APIresult.regions.map((Reg) => {
      Regions.push({
        name: "Region / " + Reg.name,
        id: Reg.id,
        type: "Region",
      });
    });
    let DropdowData = [...Bunits, ...Countries, ...Departments, ...Regions];
    setACLMappings(DropdowData);
  };

  const getInitialACLsList = () => {
    let Data = {
      criteria: {},
      size: SelectedSize,
      sorts: [
        {
          direction: "ASC",
          fieldName: "name",
        },
      ],
      start: 0,
    };
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setACLsList(Res.data.results);
        if (Res.data.results.length === 0) {
          setResultIsEmpty(true);
        } else {
          setResultIsEmpty(false);
        }
        setTotalElements(Res.data.totalElements);
        let IDs = [];
        Res.data.results.map((Item) => {
          IDs.push(Item.id);
        });
        setItemIDs(IDs);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const updatePagination = () => {
    let Count = Math.ceil(TotalElements / SelectedSize);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
  };
  // Opens and closes the small modal displayed for each row in the table based on conditions
  const openModal = (i) => {
    setPrevId(i);
    // this is a global variable set every time the user clicks on
    // a context menu, to get the permission
    // id and use it in API requests
    window.localStorage.setItem("PermissionId", i);

    setPrevModalId("modal-" + i);
    if (PreviousModalId !== undefined) {
      if (document.getElementById("modal-" + i).style.display === "block") {
        document.getElementById("modal-" + i).style.display = "none";
      } else if (
        document.getElementById("modal-" + i).style.display === "none" &&
        PreviousModalId === "modal-" + i
      ) {
        document.getElementById("modal-" + i).style.display = "block";
      } else {
        document.getElementById("modal-" + i).style.display = "block";
        document.getElementById(PreviousModalId).style.display = "none";
      }
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
  };
  // The two following functions handle icon rotation for the ViewAll button based
  // on their ID which is their index in the array from which they are mapped
  // plus the string "-trigger"
  // The open and close states are added and removed ass classNames to apply the state
  const addOpenState = (i) => {
    document
      .getElementById(i + "-trigger")
      .classList.add("trigger-icon-opened");
    document.getElementById(i + "-trigger-text").innerHTML =
      translateText("view_less");
  };
  const removeOpenState = (i) => {
    document
      .getElementById(i + "-trigger")
      .classList.remove("trigger-icon-opened");
    document.getElementById(i + "-trigger-text").innerHTML =
      translateText("view_all");
  };

  const editACL = (ACL) => {
    let ACLObject = JSON.stringify(ACL);
    let ACLBase64 = Buffer.from(ACLObject).toString("base64");
    window.localStorage.setItem("SelectedACL", ACLBase64);
    window.localStorage.setItem("ACLid", ACL.id);
    document.getElementById("edit-trigger").click();
  };
  const showDeleteAlert = (id) => {
    document.getElementById("modal-" + id).style.display = "none";
    setIdToDelete(id);
    setDeleteIsOpen(true);
  };
  // approval of delete will trigger this function to request deleting security profile
  const acceptDelete = () => {
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: { id: ItemIdToDelete },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteIsOpen(false);
        setPrevModalId(undefined);
        getInitialACLsList();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 403) {
          setDeleteIsOpen(false);
          setDeleteError({
            isShown: true,
            currentlyUsed: Err.response.data.messages,
          });
        }
      });
    setDeleteIsOpen(false);
  };
  const cancelDelete = () => {
    setDeleteIsOpen(false);
  };
  const enableDelete = () => {
    document.getElementById("delete-btn").classList.remove("disabled");
  };
  const disableDelete = () => {
    document.getElementById("delete-btn").classList.add("disabled");
  };
  const handleItemSelect = () => {
    var SelectedIDs = [];
    for (let i = 0; i < ItemIDs.length; i++) {
      if (document.getElementById("checkbox-" + ItemIDs[i]).checked) {
        SelectedIDs.push(ItemIDs[i]);
      }
    }
    if (SelectedIDs.length === 0) {
      disableDelete();
      document.getElementById("checkbox-all").checked = false;
    } else {
      enableDelete();
    }
    setSelectedItems(SelectedIDs);
  };
  // In this function, we check if the user has previously selected all items checkbox or not, then act
  // accordingly, where we select the unchecked items based on their ID which is their index inside the
  // array plus the string "checkbox-" like "checkbox-1" and so on, then we enable the delete button if
  // there are checked elements.
  const checkAll = () => {
    if (document.getElementById("checkbox-all").checked) {
      enableDelete();
      SelectedItems.splice(0, SelectedItems.length);
      for (let i = 0; i < ItemIDs.length; i++) {
        SelectedItems.push(ItemIDs[i]);
        document.getElementById("checkbox-" + ItemIDs[i]).checked = true;
      }
    } else {
      disableDelete();
      for (let i = 0; i < ItemIDs.length; i++) {
        document.getElementById("checkbox-" + ItemIDs[i]).checked = false;
      }
      SelectedItems.splice(0, SelectedItems.length);
    }
  };
  const deleteMultipleItems = () => {
    setDeleteMultipleIsOpen(true);
  };
  const acceptDeleteMultiple = () => {
    let Data = SelectedItems.filter((Item) => {
      return Item !== "ca3215af-6711-4029-800d-d583d209b7b3";
    });
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        ids: [...Data],
      },
    };
    console.log(Data);
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteMultipleIsOpen(false);
        setPrevModalId(undefined);
        getFilteredData();
        disableDelete();
        // this condition handles the use-case where an item is selected for deleting but it
        // is currently assigned to at least 1 security profile, to display the error message with the list of
        // already assigned ACLs.
        if (Res.data.currentlyUsed.length > 0) {
          setDeleteError({
            isShown: true,
            currentlyUsed: Res.data.currentlyUsed,
          });
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const uncheckAllRows = (Data) => {
    Data.map((acl) => {
      document.getElementById("checkbox-" + acl.id).checked = false;
    });
  };
  const cancelDeleteMultiple = () => {
    setDeleteMultipleIsOpen(false);
  };
  const filterByNameLike = () => {
    getFilteredData();
  };
  // our search filter has a feature where we display a clear button inside the field when the user
  // enters a value to search alongside with its active state, this function is called on the change
  // of our search field and it checks the input value and shows the button. searching functionality
  // will be added later. This function receives e which stands for event initiated by the user, it is
  //  where the search value comes from.
  const updateSearchState = (e) => {
    let SearchValue = e.target.value;
    if (SearchValue.length > 0) {
      addActiveState();
      setNameLike(SearchValue);
      filterByNameLike();
    } else {
      removeActiveState();
      setNameLike("");
      getFilteredData();
    }
  };
  const clearSearch = () => {
    removeActiveState();
    setNameLike("");
    document.getElementById("search-input").value = "";
    getFilteredData();
  };
  const addActiveState = () => {
    document.getElementById("clear-btn").style.display = "block";
    document.getElementById("input-icon").style.color = "#6DA2F2";
    document.getElementById("search-placeholder").classList.add("translated");
  };
  const removeActiveState = () => {
    document.getElementById("clear-btn").style.display = "none";
    document.getElementById("input-icon").style.color = "#DDE2EB";
    document
      .getElementById("search-placeholder")
      .classList.remove("translated");
  };

  // * This function used for fetching filtered data from the server
  const getFilteredData = (start = null) => {
    let ReqMappings = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.ACLBaseURL + "/api/location/search/all",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };
    axios(ReqMappings)
      .then((Res) => {
        console.log(Res);

        // createMappingData(Res.data);
        let APIresult = Res.data;

        let Bunit = [];
        let Country = [];
        let Department = [];
        let Region = [];
        APIresult.businesses.map((bunit) => {
          Bunit.push({
            name: "Business Unit / " + bunit.name,
            id: bunit.id,
            type: "BusinessUnit",
          });
        });
        APIresult.countries.map((country) => {
          Country.push({
            name: "Country / " + country.name,
            id: country.id,
            type: "Country",
          });
        });
        APIresult.departments.map((dept) => {
          Department.push({
            name: "Department / " + dept.name,
            id: dept.id,
            type: "Department",
          });
        });
        APIresult.regions.map((reg) => {
          Region.push({
            name: "Region / " + reg.name,
            id: reg.id,
            type: "Region",
          });
        });
        let DropdowData = [...Bunit, ...Country, ...Department, ...Region];

        let Regions = [];
        let Bunits = [];
        let Departments = [];
        let Countries = [];

        DropdowData.map((Item) => {
          if (
            document.getElementById("icon-" + Item.id) &&
            document.getElementById("icon-" + Item.id).classList.length > 1
          ) {
            if (Item.type === "Country") {
              Countries.push(Item.id);
            }
            if (Item.type === "Department") {
              Departments.push(Item.id);
            }
            if (Item.type === "BusinessUnit") {
              Bunits.push(Item.id);
            }
            if (Item.type === "Region") {
              Regions.push(Item.id);
            }
          }
        });
        let SelectedMappings = {
          businessIds: Bunits,
          countries: Countries,
          departmentIds: Departments,
          regions: Regions,
        };

        var FilterMappings = SelectedMappings;
        // if (SelectedMappings !== undefined) {
        //   FilterMappings = SelectedMappings;
        // } else {
        //   FilterMappings = MappingFilters;
        // }
        var Data = {
          criteria: {
            nameLike: document.getElementById("search-input").value,
          },
          size: SelectedSize,
          start: parseInt(document.getElementById("Start").value),
          sorts: [{ direction: Direction, fieldName: "name" }],
        };

        if (
          document.getElementById("icon-" + translateText("inactive")) &&
          document.getElementById("icon-" + translateText("inactive")).classList
            .length === 2 &&
          document.getElementById("icon-" + translateText("active")).classList
            .length === 1
        ) {
          Data.criteria.enabled = false;
        } else if (
          document.getElementById("icon-" + translateText("active")) &&
          document.getElementById("icon-" + translateText("active")).classList
            .length === 2 &&
          document.getElementById("icon-" + translateText("inactive")).classList
            .length === 1
        ) {
          Data.criteria.enabled = true;
        } else {
          delete Data.criteria.enabled;
        }
        // sorting out and defining selecte mappings for the mappings filter
        // for country, business unit, department, and region.
        if (FilterMappings) {
          if (FilterMappings.businessIds.length > 0) {
            Data.criteria.businessIds = FilterMappings.businessIds;
          } else {
            Data.criteria.businessIds = null;
          }

          if (FilterMappings.countries.length > 0) {
            Data.criteria.countryIds = FilterMappings.countries;
          } else {
            Data.criteria.countryIds = null;
          }

          if (FilterMappings.departmentIds.length > 0) {
            Data.criteria.departmentIds = FilterMappings.departmentIds;
          } else {
            Data.criteria.departmentIds = null;
          }

          if (FilterMappings.regions.length > 0) {
            Data.criteria.regionIds = FilterMappings.regions;
          } else {
            Data.criteria.regionIds = null;
          }
        }

        if (
          document.getElementById("Names-pointer-down").classList.length > 1
        ) {
          Data.sorts[0] = { direction: "DESC", fieldName: "name" };
        } else {
          Data.sorts[0] = { direction: "ASC", fieldName: "name" };
        }

        let StatusValue = parseInt(document.getElementById("Status").value);
        if (
          document.getElementById("Names-pointer-down").classList.length ===
            1 &&
          document.getElementById("Names-pointer-up").classList.length === 1
        ) {
          if (
            document
              .getElementById("Status-pointer-down")
              .classList.contains("active-filter")
          ) {
            Data.sorts[0] = { direction: "DESC", fieldName: "enabled" };
          } else if (StatusValue === 2) {
            Data.criteria.enabled = false;
          } else {
            if (Data.criteria.enabled !== undefined) {
              Data.sorts[0] = { direction: "ASC", fieldName: "enabled" };
            }
          }
        }
        if (start !== null) {
          Data.start = start
        }
        var Req = {
          method: "post",
          baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl/search",
          headers: {
            Authorization: "Bearer " + window.localStorage.getItem("Token"),
            "Content-Type": "application/json",
          },
          data: JSON.stringify(Data),
        };
        axios(Req)
          .then((Res) => {
            console.log(Res);
            if (Res.data.results.length === 0) {
              setResultIsEmpty(true);
            } else {
              setResultIsEmpty(false);
            }
            setACLsList(Res.data.results);
            setTotalElements(Res.data.totalElements);
            createPagination(Res.data.totalElements);
            if (
              document.getElementById("next-page") &&
              Res.data.totalElements <= SelectedSize
            ) {
              document
                .getElementById("next-page")
                .classList.add("page-btn-disabled");
            }
            let IDs = [];
            Res.data.results.map((Item) => {
              IDs.push(Item.id);
            });
            setItemIDs(IDs);
            if (document.getElementById("1-page-btn") === null) {
              return null;
            } else {
              start !== null ? updatePaginationActiveClass('1-page-btn') : updatePaginationActiveClass(
                document.getElementById("PrevId").value
              );
            }
            uncheckAllRows(Res.data.results);
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createPagination = (TotalCount) => {
    let Count = Math.ceil(TotalCount / SelectedSize);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };
  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    console.log('have add active page')
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };
  const handleListByStatus = useCallback(() => {
    let SelectedStatuses = Array(
      document.getElementById("Status-filter").value
    );
    if (SelectedStatuses.length === 2 || SelectedStatuses.length === 3) {
      document.getElementById("Status").value = "0";
    } else if (
      SelectedStatuses.length === 1 &&
      SelectedStatuses[0] === translateText("active")
    ) {
      document.getElementById("Status").value = "1";
    } else if (
      SelectedStatuses.length === 1 &&
      SelectedStatuses[0] == translateText("inactive")
    ) {
      document.getElementById("Status").value = "2";
    } else {
      setIsActive(undefined);
    }
    setTimeout(() => {
      getFilteredData(0);
    }, 1000);
  }, [IsActive]);
  const handleListByStatusFilterOnly = () => {
    document
      .getElementById("Names-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Names-pointer-down")
      .classList.remove("active-filter");
    let Counter = StatusFilterCounter;
    let NewCount = parseInt(Counter + 1);
    if (NewCount < 3) {
      setStatusFilterCounter(NewCount);
      if (NewCount === 1) {
        addActiveStatusState();
        document.getElementById("Status").value = "1";
      } else if (NewCount === 2) {
        addInactiveStatusState();
        document.getElementById("Status").value = "2";
      } else {
        removeActiveState();
        document.getElementById("Status").value = "0";
      }
    } else {
      setStatusFilterCounter(0);
    }
    getFilteredData();
  };
  const addActiveStatusState = () => {
    document.getElementById("Status-pointer-up").classList.add("active-filter");
    document
      .getElementById("Status-pointer-down")
      .classList.remove("active-filter");
  };
  const addInactiveStatusState = () => {
    document
      .getElementById("Status-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Status-pointer-down")
      .classList.add("active-filter");
  };
  const filterByName = () => {
    document
      .getElementById("Status-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Status-pointer-down")
      .classList.remove("active-filter");

    getFilteredData();
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
    if (NextPage > 1 && Pages.length > 1) {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
    if (PrevPage === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
  };
  const requestPageNumber = useCallback(
    (PageNumber) => {
      let NewStart = (PageNumber - 1) * SelectedSize;
      document.getElementById("Start").value = NewStart;
      document.getElementById("PrevId").value = PageNumber + "-page-btn";
      setPrevId(PageNumber + "-page-btn");
      updatePaginationActiveClass(document.getElementById("PrevId").value);
      setStart(NewStart);
      getFilteredData();
      if (PageNumber === 1) {
        document.getElementById("prev-page").classList.add("page-btn-disabled");
      } else {
        document
          .getElementById("prev-page")
          .classList.remove("page-btn-disabled");
      }
      if (PageNumber === Pages.length) {
        document.getElementById("next-page").classList.add("page-btn-disabled");
      } else {
        document
          .getElementById("next-page")
          .classList.remove("page-btn-disabled");
      }
    },
    [Start, SelectedSize]
  );
  const updatePaginationActiveClass = (CurrentId) => {
    console.log("current id", CurrentId)
    console.log("prev id", PrevId)
    console.log(document.getElementById(CurrentId))
    if (document.getElementById("1-page-btn") !== null)
      if (PrevId.length === 0 || PrevId === CurrentId) {
        document.getElementById("1-page-btn").classList.remove("active-page");
        document.getElementById(CurrentId).classList.add("active-page");
      } else {
        if (document.getElementById(PrevId))
          document.getElementById(PrevId).classList.remove("active-page");
        document.getElementById(CurrentId).classList.add("active-page");
      }
  };

  const resetFilters = () => {
    if (document.getElementById("ACL-clear") !== null) {
      document.getElementById("ACL-clear").click();
    }
    if (document.getElementById("Status-clear") !== null) {
      document.getElementById("Status-clear").click();
    }
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    getFilteredData();
  };

  const createChips = (Restrictions, ACL) => {
    let BUnits = [];
    let Countries = [];
    let Depts = [];
    let Regions = [];
    Restrictions.businesses.map((BUnit) => {
      BUnits.push("Business Unit - " + BUnit.name);
    });
    Restrictions.departments.map((Dept) => {
      Depts.push("Department - " + Dept.name);
    });
    Restrictions.countries.map((Country) => {
      Countries.push("Country - " + Country);
    });
    Restrictions.regions.map((Region) => {
      Regions.push("Region - " + Region);
    });
    let ChipData = [...BUnits, ...Countries, ...Depts, ...Regions];
    let TriggerItems = [
      ChipData[0],
      ChipData[1],
      ChipData[2],
      ChipData[3],
      ChipData[4],
    ];
    let ViewMoreItems = ChipData.splice(5, ChipData.length);

    if (Restrictions !== null) {
      return (
        <React.Fragment>
          {ChipData.length < 5 ? (
            <section className="chip-holder">
              <React.Fragment>
                {ChipData.map((Item) => (
                  <React.Fragment>
                    {Item.length > 23 ? (
                      <p className="small-chip">
                        {shortenChipName(Item)}
                        <p>{Item}</p>
                      </p>
                    ) : (
                      <p className="small-chip">{Item}</p>
                    )}
                  </React.Fragment>
                ))}
              </React.Fragment>
            </section>
          ) : (
            <Collapsible
              onOpening={() => addOpenState(ACL.id)}
              onClosing={() => removeOpenState(ACL.id)}
              trigger={
                <section className="chip-holder">
                  <React.Fragment>
                    {TriggerItems.map((Item) => (
                      <React.Fragment>
                        {Item.length > 23 ? (
                          <p className="small-chip">
                            {shortenChipName(Item)}
                            <p>{Item}</p>
                          </p>
                        ) : (
                          <p className="small-chip">{Item}</p>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                  <button className="trig-more">
                    <p id={ACL.id + "-trigger-text"}>
                      {translateText("view_all")}
                    </p>
                    <img
                      className="trigger-icon-closed"
                      id={ACL.id + "-trigger"}
                      alt=""
                      src={Up}
                    />
                  </button>
                </section>
              }
            >
              <section className="chip-holder all-data">
                {ViewMoreItems.map((Item) => (
                  <React.Fragment>
                    {Item.length > 23 ? (
                      <p className="small-chip">
                        {shortenChipName(Item)}
                        <p>{Item}</p>
                      </p>
                    ) : (
                      <p className="small-chip">{Item}</p>
                    )}
                  </React.Fragment>
                ))}
              </section>
            </Collapsible>
          )}
        </React.Fragment>
      );
    }
  };
  const shortenChipName = (Name) => {
    if (Name.length > 23) {
      return Name.slice(0, 20) + " ...";
    } else {
      return Name;
    }
  };
  const handleListByMappings = () => {
    let Regions = [];
    let Bunits = [];
    let Departments = [];
    let Countries = [];

    ACLMappings.map((Item) => {
      if (document.getElementById("icon-" + Item.id).classList.length > 1) {
        if (Item.type === "Country") {
          Countries.push(Item.id);
        }
        if (Item.type === "Department") {
          Departments.push(Item.id);
        }
        if (Item.type === "BusinessUnit") {
          Bunits.push(Item.id);
        }
        if (Item.type === "Region") {
          Regions.push(Item.id);
        }
      }
    });
    let SelectedItems = {
      businessIds: Bunits,
      countries: Countries,
      departmentIds: Departments,
      regions: Regions,
    };
    // getFilteredData(SelectedItems);
    // setMappingFilters(SelectedItems);
  };
  const handleMenuClassName = (Id) => {
    if (Id === "ca3215af-6711-4029-800d-d583d209b7b3") {
      return "modal-body double-item modal-body-disabled";
    } else {
      return "modal-body double-item";
    }
  };

  useEffect(() => {
    if (document.getElementById("1-page-btn") !== null) {
      document.getElementById("1-page-btn").click();
    }
  }, [SelectedSize])

  const setSize = () => {
    setSelectedSize(parseInt(document.getElementById("pre-selected-row-per-page").innerHTML))
  }

  return (
    <React.Fragment>
      <input className="hidden" type="number" id="Start" />
      <input
        className="hidden"
        type="number"
        id="Status"
        value="0"
        max="2"
        min="0"
      />
      <input className="hidden" id="PrevId" defaultValue="1-page-btn" />
      <DesktopOnlyPageOverlay LangData={props.LangData} />
      {DeleteMultipleIsOpen ? (
        <MultipleDeleteAlert
          acceptDeleteMultiple={() => acceptDeleteMultiple()}
          cancelDeleteMultiple={() => cancelDeleteMultiple()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {DeleteIsOpen ? (
        <Alert
          acceptDelete={() => acceptDelete()}
          cancelDelete={() => cancelDelete()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {DeleteError.isShown ? (
        <ErrorModal
          Data={DeleteError.currentlyUsed}
          Close={() => setDeleteError({ isShown: false })}
          Type={"ACL(s)"}
          LangData={props.LangData}
        />
      ) : null}
      <div className="main-content security-settings security-profiles">
        <ContentHeader PageName={translateText("access_control_lists")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("security_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("acls")}</p>
          </div>
        </div>
        <div className="actions">
          <section className="button-group">
            <button
              onClick={() => deleteMultipleItems()}
              id="delete-btn"
              className="act disabled"
            >
              <i className="feather-trash"></i>
              <p>{translateText("delete")}</p>
            </button>
          </section>
          <NavLink to="/addACL">
            <button className="add-user">
              <img alt="" src={Plus} /> <p>{translateText("add_acl")}</p>
            </button>
          </NavLink>
        </div>
        <div className="filters">
          <p className="title-text">{translateText("filters")}</p>
          <div className="flex">
            <SearchInput
              filterByNameLike={() => filterByNameLike()}
              ChangeHandler={(e) => updateSearchState(e)}
              clearSearch={() => clearSearch()}
              PlaceHolder={translateText("search") + " ..."}
              Id="search"
            />
            <MultiSelect
              Name={translateText("mapping")}
              Initial={"All records"}
              Options={ACLMappings}
              IsWithId
              Id="ACL"
              ChangeHandler={() => getFilteredData(0)}
            />
            <MultiSelect
              Name={translateText("status")}
              Initial={"All Statuses"}
              Options={[translateText("active"), translateText("inactive")]}
              Id="Status"
              ChangeHandler={() => handleListByStatus()}
            />
          </div>
        </div>
        <div className="information">
          <div className="data-table">
            <section className="table-header flex">
              <div className="xsmall">
                <label className="blue-checkbox-rounded-label">
                  <input
                    onChange={() => checkAll()}
                    type="checkbox"
                    id="checkbox-all"
                    class="blue-checkbox"
                  />
                  <i className="check-all"></i>
                </label>
              </div>
              <TableFilter
                className="large with-padding-left sorts"
                Name={translateText("names")}
                Id="Names"
                IsActive
                ChangeEvent={() => filterByName()}
              />
              <div className="large">{translateText("mapping")}</div>
              <TableFilter
                IsActive={false}
                className="medium sorts"
                Name={translateText("status")}
                Id="Status"
                ChangeEvent={() => handleListByStatusFilterOnly()}
              />
            </section>
            <div className="table-body">
              {ACLsList.map((ACL, i) => (
                <div className="table-item flex" key={ACL.id}>
                  <div className="xsmall">
                    <>
                      {ACL.id === "ca3215af-6711-4029-800d-d583d209b7b3" ? (
                        <label className="blue-checkbox-rounded-label disabled-checkbox-wrapper">
                          <input
                            onChange={() => handleItemSelect()}
                            type="checkbox"
                            class="blue-checkbox"
                            id={"checkbox-" + ACL.id}
                          />
                          <i></i>
                        </label>
                      ) : (
                        <label className="blue-checkbox-rounded-label">
                          <input
                            onChange={() => handleItemSelect()}
                            type="checkbox"
                            class="blue-checkbox"
                            id={"checkbox-" + ACL.id}
                          />
                          <i></i>
                        </label>
                      )}
                    </>
                  </div>
                  <div className="large with-padding-left name">{ACL.name}</div>
                  <div className="large profiles">
                    {ACL.restriction ? (
                      <React.Fragment>
                        {createChips(ACL.restriction, ACL)}
                      </React.Fragment>
                    ) : null}
                  </div>
                  <div className="medium status">
                    {ACL.enabled || ACL.enabled === null ? (
                      <React.Fragment>
                        <section className="active"></section>
                        <p>{translateText("active")}</p>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <section className="deactive"></section>
                        <p>{translateText("inactive")}</p>
                      </React.Fragment>
                    )}
                  </div>
                  <div className="more">
                    <button
                      onClick={() => openModal(ACL.id)}
                      className="btn-more"
                    ></button>
                    <div className="modal-space" id={"modal-" + ACL.id}>
                      <div
                        className="outline"
                        onClick={() => openModal(PrevId)}
                      ></div>
                      <div className={handleMenuClassName(ACL.id)}>
                        <NavLink id="edit-trigger" to={`/editACL`}></NavLink>
                        <button onClick={() => editACL(ACL)} className="btn">
                          <img alt="" src={Pencil} />
                          <div className="btn-text">
                            <p>{translateText("edit")}</p>
                            <p>{translateText("edit_acl")}</p>
                          </div>
                        </button>
                        <button
                          className="btn"
                          onClick={() => showDeleteAlert(ACL.id)}
                        >
                          <img alt="" src={Delete} />
                          <div className="btn-text">
                            <p>{translateText("delete")}</p>
                            <p>{translateText("delete_acl_permenantly")}</p>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {ResultIsEmpty ? (
            <div className="empty-state">
              <img alt="" src={EmptyState} />
              <p>{translateText("empty_state_text")}</p>
              <button onClick={() => resetFilters()}>
                {translateText("reset_filters")}
              </button>
            </div>
          ) : (
            <div className="page-footer">
              <section className="pagination-holder">
                <button
                  onClick={() => requestPrevPage()}
                  id="prev-page"
                  className="page-btn page-btn-disabled"
                >
                  <i className="feather-chevron-left"></i>
                </button>
                <React.Fragment>
                  {Pages.length < 6 ? (
                    <React.Fragment>
                      {Pages.map((Page) => (
                        <React.Fragment>
                          {Page === 1 ? (
                            <button
                              key={Page}
                              onClick={() => requestPageNumber(Page)}
                              className="page-btn active-page"
                              id={Page + "-page-btn"}
                            >
                              {Page}
                            </button>
                          ) : (
                            <button
                              key={Page}
                              onClick={() => requestPageNumber(Page)}
                              className="page-btn"
                              id={Page + "-page-btn"}
                            >
                              {Page}
                            </button>
                          )}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <button
                        onClick={() => requestPageNumber(1)}
                        className="page-btn active-page"
                        id={1 + "-page-btn"}
                      >
                        {1}
                      </button>
                      {PageInfo.FirstDotsShown ? <p>...</p> : null}
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                        }
                        className="page-btn"
                        id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage - 1)}
                      </button>
                      {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                        <button
                          onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                          className="page-btn"
                          id={PageInfo.MiddlePage + "-page-btn"}
                        >
                          {PageInfo.MiddlePage}
                        </button>
                      )}
                      {parseInt(PageInfo.MiddlePage + 1) >=
                      PageInfo.LastPage ? null : (
                        <button
                          onClick={() =>
                            requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                          }
                          className="page-btn "
                          id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                        >x
                          {parseInt(PageInfo.MiddlePage + 1)}
                        </button>
                      )}
                      {!PageInfo.LastDotsShown ? <p>...</p> : null}
                      <button
                        onClick={() => requestPageNumber(PageInfo.LastPage)}
                        className="page-btn"
                        id={PageInfo.LastPage + "-page-btn"}
                      >
                        {PageInfo.LastPage}
                      </button>
                    </React.Fragment>
                  )}
                </React.Fragment>
                <button
                  onClick={() => requestNextPage()}
                  id="next-page"
                  className="page-btn"
                >
                  <i className="feather-chevron-right"></i>
                </button>
              </section>
              <p className="small-info-footer">
                {translateText("showing")} {Start + 1} {translateText("to")}{" "}
                {Start + SelectedSize <= TotalElements ? Start + SelectedSize : TotalElements} {translateText("of")} {TotalElements}{" "}
                {translateText("items")}.
              </p>
              <PaginationRowSelector SizeOptions={SizeOptions} setSize={() => setSize()} LangData={props.LangData}/>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ACLs;
